module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/layouts/admin/admin.component.html
// module id = ../../../../../src-admin/app/layouts/admin/admin.component.html
// module chunks = main